export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/faqsMobileBanner.6607d694.svg","height":242,"width":381,"blurWidth":0,"blurHeight":0};